import { Component, OnInit } from '@angular/core';
import { PopupService } from '../../../../../services/popup.service';
import { RetailerService } from '../../../../../services/retailer.service';
import { PropertyService } from '../../../../../services/property.service';
import { LoaderService } from '../../../../../services/loader.service';
import { Observable } from 'rxjs/Rx';
import { states } from '../../../../../constants/Global';
import { RemovedItemsService } from "../../../../../services/removed-items.service";
import {MyStuffService} from "../../../../../services/my-stuff.service";

@Component({
  selector: 'app-removed-retailers',
  templateUrl: './removed-retailers.component.html',
  styleUrls: ['./removed-retailers.component.less']
})
export class RemovedRetailersComponent implements OnInit {

  states = states;

  constructor(public popupService: PopupService, public retailerService: RetailerService,
              public propertyService: PropertyService, public loaderService : LoaderService,
              public removedItemsService : RemovedItemsService, public myStuffService : MyStuffService) { }

  ngOnInit() {
    if(this.popupService.popupList.popups['my-stuff'] && !this.myStuffService.myStuffSectionOpened.deletedRetailers) {
      this.removedItemsService.fetchRemovedRetailersSource.next(true);
      this.myStuffService.myStuffSectionOpened.deletedRetailers = true;
    }
  }

  ngAfterViewInit() {
    this.removedItemsService.removedRetailersAddInputEventObservable();
  }

  applyWidth(item) {
    if(item.logoPinImage && item.logoPinImage.url && item.logoPinImage.originalWidth && item.logoPinImage.originalHeight) {
      if(item.logoPinImage.originalWidth >= item.logoPinImage.originalHeight) {
        return true;
      }
    } else if(item.smallPinImage && item.smallPinImage.url && item.smallPinImage.originalWidth && item.smallPinImage.originalHeight) {
      if(item.smallPinImage.originalWidth >= item.smallPinImage.originalHeight) {
        return true;
      }
    }
    return false;
  }

  applyHeight(item) {
    if(item.logoPinImage && item.logoPinImage.url && item.logoPinImage.originalWidth && item.logoPinImage.originalHeight) {
      if(item.logoPinImage.originalWidth < item.logoPinImage.originalHeight) {
        return true;
      }
    } else if(item.smallPinImage && item.smallPinImage.url && item.smallPinImage.originalWidth && item.smallPinImage.originalHeight) {
      if(item.smallPinImage.originalWidth < item.smallPinImage.originalHeight) {
        return true;
      }
    }
    return false;
  }

  paginate() {
    this.removedItemsService.fetchDeletedRetailers();
  }

  addBackDeletedItem(item) {
    item.itemType = 'retailer';
    this.myStuffService.addBackDeletedItem(item);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/removed-items/removed-retailers/removed-retailers.component.ts